import i18next, { type TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultNS, namespaces, resources, type Namespace } from './resources';

export const i18n = i18next.createInstance();

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  ns: namespaces,
  defaultNS,
  interpolation: { escapeValue: false },
  returnNull: false,
  // Resources are bundled, so initialisation is synchronous and tests need no waiting.
  initAsync: false,
});

/** The locale for `Intl` formatting (dates and numbers). */
export function currentLocale(): string {
  return i18n.resolvedLanguage ?? i18n.language;
}

/**
 * Translates a key that is only known at runtime, e.g. a nav label declared by a feature as `{ ns, labelKey }`.
 * Prefer the typed `t('literal.key')` everywhere else.
 */
export function translateDynamic(t: TFunction, ns: Namespace, key: string): string {
  return (t as unknown as (key: string, options: { ns: Namespace }) => string)(key, { ns });
}

export { defaultNS, namespaces, resources };
export type { FeatureNamespace, Namespace } from './resources';
